import { struct } from 'io-ts/Decoder';

import { Id as GroupId } from '../../../../../../whole-house/canvas/group/Id';
import { Id as CanvasId } from '../../../../../../whole-house/canvas/Id';

export const Params = struct({
	canvasId: CanvasId,
	groupId: GroupId,
});
